import * as actions from '@actions';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

export function usePatientDetails() {
  const { appointment } = useSessionAppointment();
  const dispatch = useDispatch();

  const { data: patientDetails } = useQuery({
    queryKey: ['/referrers/patients/', appointment.clinician_user_guid, appointment.patient_user_guid],
    queryFn: () => dispatch(actions.getPatientDetails(appointment.clinician_user_guid, appointment.patient_user_guid)),
    enabled: !!appointment
  });

  return patientDetails?.users?.[0];
}

export default usePatientDetails;
